export default __webpack_public_path__ + "static/media/banner4.dfb8e597.jpg";